import(/* webpackMode: "eager" */ "/app/app/applicant/jobs/page.tsx");
